
import { lazyLoad } from 'utils/loadable';
import {ShoutoutAwardGeneratePage} from "./index";

export const ShoutoutAwardsGenerate = lazyLoad(
    () => import('./index'),
    module => module.ShoutoutAwardGeneratePage,
);
